import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Screen, Text, Input, TableAdmin } from '../../../components';
import { Row, Col } from 'react-bootstrap';
const moment = require('moment');

import pressRoomService from '../../../services/pressroom';

const { defaultStates, defaultAlertScreenOnClick } = require('../../../utils/defaults');

class PressRoomList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentsWithFiles: [], 
      documentsWithUrls: [],
      ...defaultStates(),
    };

    this.modalOnHide = this.modalOnHide.bind(this);
    this.alertScreenOnClick = this.alertScreenOnClick.bind(this);
    this.body = this.body.bind(this);
    this.footer = this.footer.bind(this);
    this.fillTable = this.fillTable.bind(this);
  }

  async componentDidMount() {
    await this.fillTable();
  }

  async fillTable(error = true) {
    this.setState({ loadingState: true });

    const response = await pressRoomService.admin.getList();
    if (response.ok && response.data) {
      const data = response.data.map((i) => {
        return {
          ...i,
          isActive: i.isActive ? 'Ativo' : 'Rascunho',
          postingDate: i.postingDate ? moment(i.postingDate).utc().format('DD/MM/YYYY') : '',
        };
      });

      const documentsWithFiles = data.filter(item => item.type === 'releases');
      const documentsWithUrls = data.filter(item => item.type === 'midia');

      this.setState({ 
        documentsWithFiles,
        documentsWithUrls 
      });
    } else {
      if (error) {
        const modalState = {
          title: 'Erro',
          text: response.message,
          toggle: true,
          onHide: this.modalOnHide,
        };
        this.setState({ modalState });
      }
    }

    this.setState({ loadingState: false });
  }

  modalOnHide() {
    const { modalState } = this.state;
    modalState.toggle = false;
    this.setState(modalState);
    this.fillTable(false);
  }

  alertScreenOnClick() {
    defaultAlertScreenOnClick(this);
  }

  body() {
    const onCellClick = ({ id }) => this.props.history.push(`/gestao/pressroom/${id}`);

    const columnsFiles = [
      { headerName: 'ID', field: 'id', hide: true, flex: 0.05 },
      { headerName: 'Nome', field: 'title', flex: 0.4 },
      { headerName: 'Status', field: 'isActive', flex: 0.2 },
    ];

    const columnsUrls = [
      { headerName: 'ID', field: 'id', hide: true, flex: 0.05 },
      { headerName: 'Nome', field: 'title', flex: 0.4 },
      { headerName: 'URL', field: 'url', flex: 0.4 },
      { headerName: 'Data da postagem', field: 'postingDate', flex: 0.4,},
      { headerName: 'Status', field: 'isActive', flex: 0.2 },
    ];

    return (
      <>
        <Row align={'center'}>
          <Col>
            <Text title text={'Sala de Imprensa'} />
          </Col>
        </Row>
        <Row align="right">
          <Col>
            <Button
              underlinePlus
              text={'Adicionar Novo'}
              onClick={() => this.props.history.push('/gestao/pressroom/novo')}
            />
          </Col>
        </Row>

        {this.state.documentsWithFiles.length > 0 && (
          <>
            <Row className="mt-4">
              <Col>
                <Text className="mb-0" text={'Releases'} style={{ fontSize: '18px', fontWeight: 'bold' }} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col>
                <TableAdmin
                  onCellClick={onCellClick}
                  data={this.state.documentsWithFiles}
                  columns={columnsFiles}
                />
              </Col>
            </Row>
          </>
        )}

        {this.state.documentsWithUrls.length > 0 && (
          <>
            <Row className="mt-4">
              <Col>
                <Text className="mb-0" text={'FGCoop na Mídia'} style={{ fontSize: '18px', fontWeight: 'bold' }} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col className="mt-3">
                <TableAdmin
                  onCellClick={onCellClick}
                  data={this.state.documentsWithUrls}
                  columns={columnsUrls}
                />
              </Col>
            </Row>
          </>
        )}

        {this.state.documentsWithFiles.length === 0 && this.state.documentsWithUrls.length === 0 && (
          <Row className="justify-content-center mt-4">
            <Col>
              <Text text={'Nenhum documento encontrado'} />
            </Col>
          </Row>
        )}
      </>
    );
  }

  footer() {
    return (
      <>
        <Row align="center"></Row>
      </>
    );
  }

  render() {
    const { modalState, alertScreenState, loadingState } = this.state;

    return (
      <Screen
        admin
        body={this.body}
        footer={this.footer}
        modalState={modalState}
        loadingState={loadingState}
        alertScreenState={alertScreenState}
      />
    );
  }
}

PressRoomList.propTypes = {
  //props
  match: PropTypes.object,
  history: PropTypes.object,
};

export default PressRoomList;
